import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sidebar-admin no-printable"
}
const _hoisted_2 = { class: "dashboard d-flex justify-content-between" }
const _hoisted_3 = {
  class: "w-100 printable-remove",
  style: {"padding-left":"320px"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "tw-p-5" }, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "printable-template",
    class: "printable"
  })
], -1)

import Sidebar from '@/components/admin/Sidebar.vue';

import UserService from '@/shared/services/user.service';

import { ref } from 'vue';




export default /*#__PURE__*/_defineComponent({
  __name: 'AdminView',
  setup(__props) {


const userRole = ref(null)

const usersession = ref(null)



const getSession = () => {

    let session = localStorage.getItem("usersession") && localStorage.getItem("usersession").length > 0 ? JSON.parse(localStorage.getItem("usersession")) : null

    if (session) {

        userRole.value = session.role ? session.role : session.tipo_rol

        usersession.value = session

    } else {

        UserService.logout("Session expired!")

    }

}

getSession()


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    (usersession.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(Sidebar, {
              usersession: usersession.value,
              userRole: userRole.value
            }, null, 8, ["usersession", "userRole"]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_router_view)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_4
  ]))
}
}

})